import { DataGrid } from '@mui/x-data-grid'
import React from 'react'
import CustomDataGrid from '../DataGrid/CustomDataGrid'

const ListTab = ({ rows, columns, onRowClick }) => {
  return (
    <CustomDataGrid
      rows={rows}
      columns={columns}
      disableColumnMenu
      disableColumnFilter
      disableColumnSelector
      disableRowSelectionOnClick
      onRowClick={onRowClick}
    />
  )
}

export default ListTab
